export default "__VITE_ASSET__wXNJ8at0__"